module.exports = {
  context: {
    masthead: '@masthead',
    hero: {
      type: 'article',
      heading: {
        text: 'Adjoin to partner with STRIVE',
        tag: 'h1',
        class: 'heading-1'
      },
      date: 'February 24, 2021',
      entryType: 'Press Release',
      breadcrumbs: '@breadcrumb'
    },
    contentModules: '@content-modules',
    footer: '@footer'
  }
}
